// 课程报名统计
const CourseEnrollAnalysis = () =>
  import('@pv/analysisCenter/dataAnalysis/CourseEnrollAnalysis');

// 课程报名班级汇总
const CourseEnrollClassSummary = () =>
  import('@pv/analysisCenter/dataAnalysis/CourseEnrollClassSummary');

export default [
  {
    path: '/analysisCenter/dataAnalysis/courseEnrollAnalysis',
    name: 'analysisCenter_dataAnalysis_courseEnrollAnalysis',
    meta: {
      title: '课程报名统计',
      activePath: '/analysisCenter/dataAnalysis/courseEnrollAnalysis',
      breadcrumb: '数据统计-报名统计-课程报名统计',
      showChangeSchool: true
    },
    component: CourseEnrollAnalysis
  },
  {
    path: '/analysisCenter/dataAnalysis/courseEnrollClassSummary',
    name: 'analysisCenter_dataAnalysis_courseEnrollClassSummary',
    meta: {
      title: '课程报名班级汇总',
      activePath: '/analysisCenter/dataAnalysis/courseEnrollClassSummary',
      breadcrumb: '数据统计-报名统计-课程报名班级汇总',
      showChangeSchool: true
    },
    component: CourseEnrollClassSummary
  }
];
